/**
 * Named normalizers. A field composes one or more by name via `normalizeWith`.
 * Additional normalizers register through `registerNormalizer` — the second
 * of the three FIELDS.md seams. See FIELDS.md § The three seams.
 */
type Normalizer = (input: string) => string;

const normalizers = new Map<string, Normalizer>([
  ['trim', (s) => s.trim()],
  ['upper', (s) => s.toUpperCase()],
  ['lower', (s) => s.toLowerCase()],
  ['stripSpaces', (s) => s.replace(/\s+/g, '')],
  ['stripPunct', (s) => s.replace(/[^\w+]/g, '')],
  ['collapseSpaces', (s) => s.replace(/\s+/g, ' ').trim()],
]);

export function registerNormalizer(name: string, fn: Normalizer): void {
  normalizers.set(name, fn);
}

export function normalize(value: string, names: readonly string[]): string {
  let out = value;
  for (const name of names) {
    const fn = normalizers.get(name);
    if (fn) out = fn(out);
  }
  return out;
}
